<template>
  <div class="movement-history-view card border-0">
    <div class="card-body">
      <movement-history-list :entries="entries" :loading="loading"/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import InventoryService from "@/modules/inventory/InventoryService";
  import MovementHistoryList from "./MovementHistoryList";

  const {mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "MovementHistoryView",
    components: {MovementHistoryList},
    data() {
      return {
        entries: [],
        loading: false,
      };
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
      }),
    },
    watch: {
      inventory: {
        immediate: true,
        handler(val) {
          if (val && val.uuid) {
            this.fetchHistory();
          }
        }
      },
      'inventory.movement_history_count'() {
        if (this.inventory && this.inventory.uuid) {
          this.fetchHistory();
        }
      }
    },
    methods: {
      async fetchHistory() {
        this.loading = true;
        const response = await InventoryService.getMovementHistory(this.inventory.uuid);
        this.loading = false;
        if (response.success) {
          this.entries = response.body.results || response.body || [];
        } else {
          this.entries = [];
        }
      }
    }
  }
</script>
